import { SEEK_FACEBOOK_URL, SEEK_TWITTER_URL } from '@seek/shared-constants';
import {
  Box,
  ButtonIcon,
  IconSocialFacebook,
  IconSocialX,
  Inline,
} from 'braid-design-system';
import type React from 'react';

import { Link } from 'src/components';
import type { Site, SitesAll } from 'src/shared/types';

interface Props {
  site: SitesAll;
}

export const SocialMediaInfo = ({ site }: Props) => (
  <Box>
    <Inline space="small">
      <Link
        id="social-link-facebook"
        target="_blank"
        href={SEEK_FACEBOOK_URL[site as Site]}
        tracking="content_element_pressed"
      >
        <ButtonIcon
          id="facebook-link"
          label="Visit us on Facebook"
          icon={<IconSocialFacebook />}
        />
      </Link>
      <Link
        target="_blank"
        href={SEEK_TWITTER_URL[site as Site]}
        tracking="content_element_pressed"
      >
        <ButtonIcon id="x-link" label="Visit us on X" icon={<IconSocialX />} />
      </Link>
    </Inline>
  </Box>
);
